import React from "react";
import ReactDOM from "react-dom/client";
import 'react-quill/dist/quill.snow.css';
import "jsvectormap/dist/css/jsvectormap.css";
import 'react-toastify/dist/ReactToastify.css';
import 'react-modal-video/css/modal-video.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import App from "./App";
import * as serviceWorker from "./serverWorker";
import reportWebVitals from "./reportWebVitals";
import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';
import { getAuth, signInAnonymously } from 'firebase/auth';
export const API_URL =  "https://api.test.frontforcecrm.com"
export const API_URL_LOCAL=  "https://api.test.frontforcecrm.com"
export const CHAT_UPLOAD_URL = `${API_URL}/api/chat/upload-attachments`;
export function formatDateAccordingTo(dateString) {
  // Handle null or invalid date strings
  if (!dateString) {
    return '';
  }
  const date = new Date(dateString);

  // Check if the date is valid
  if (isNaN(date.getTime())) {
    return '';
  }

  // Get the current date
  const currentDate = new Date();

  // Check if the date matches the current date
  const isToday =
    date.getFullYear() === currentDate.getFullYear() &&
    date.getMonth() === currentDate.getMonth() &&
    date.getDate() === currentDate.getDate();

  // Format the date based on whether it matches the current date
  if (isToday) {
    // Format as time only (e.g., 10:10 AM)
    return new Intl.DateTimeFormat('en-US', {
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
    }).format(date);
  } else {
    // Format as date and time (e.g., 12 Mar 2025 10:10 AM)
    return new Intl.DateTimeFormat('en-US', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
    }).format(date);
  }
}

const firebaseConfig = {
    apiKey: "AIzaSyDVSUFBgG1iTUnwZ7JBus6zIovNMR6A1NY",
    authDomain: "r-wire.firebaseapp.com",
    databaseURL: "https://r-wire-default-rtdb.firebaseio.com",
    projectId: "r-wire",
    storageBucket: "r-wire.firebasestorage.app",
    messagingSenderId: "614864444194",
    appId: "1:614864444194:web:9685f606d62ca5af47a37b",
    measurementId: "G-P0FYR359R5"
};

// Initialize Firebase

const app = initializeApp(firebaseConfig);
export const db = getDatabase(app);
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <App />
  </>
);

serviceWorker.unregister()
reportWebVitals();
